///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: 'div[windeGridCell]',
    standalone: false
})
export class GridCellDirective {
    @HostBinding('class') buttonClass = 'winde-grid-cell';
    @HostBinding('style.max-width') @Input() maxWidth: string;
}
